import React from "react";
import { useNavigate } from "react-router-dom";
import PropertyForm from "../components/PropertyForm";
import RequireRole from "../components/RequireRol";

const NewProperty = () => {
    const navigate = useNavigate();

    return (
        <RequireRole
            allowedRoles={["propietario", "admin", "gestor_inmobiliario"]}
            customMessage="Solo los propietarios y administradores pueden añadir nuevas propiedades."
        >
            <div className="container mx-auto px-4 py-8">
                <button
                    onClick={() => navigate(-1)}
                    className="mb-4 text-blue-600 hover:underline"
                >
                    ← Volver
                </button>
                <PropertyForm />
            </div>
        </RequireRole>
    );
};

export default NewProperty; 